/**
 * Get Object From Target
 */
const getObjectFromTarget = <T, K = Record<string, T>>(target: K | any): K =>
  (typeof target === 'object' ? target : {}) ?? {};

export { getObjectFromTarget };
